// 一時保存
export function temporarilySave () {
  // 一時保存フラグ
  let temporarily_flg = document.querySelector('.temporarily-flg');
  // 登録または更新ボタン
  let submitButton = document.querySelector('.submit-button');
  // 一時保存ボタン
  let temporarilyButton = document.querySelector('.temporarily-button');

  if (!!submitButton) {
    submitButton.addEventListener('click', function(event) {
      // 連打防止
      submitButton.disabled = true;
      // ボタンのテキストを変更
      changeButtonText(submitButton);

      let form = submitButton.closest('form');
      if (!!form) {
        if (!!temporarily_flg) {
          temporarily_flg.value = false;
        }
        form.submit();
      }
    })
  }

  if (!!temporarilyButton) {
    temporarilyButton.addEventListener('click', function(event) {
      // 連打防止
      temporarilyButton.disabled = true;
      // ボタンのテキストを変更
      changeButtonText(temporarilyButton);

      let form = temporarilyButton.closest('form');
      if (!!form) {
        if (!!temporarily_flg) {
          temporarily_flg.value = true;
        }
        form.submit();
      }
    })
  }
}

// ボタンのテキストを変更
function changeButtonText (button) {
  let afterWord = button.dataset['afterWord'];
  if (!!afterWord) {
    button.textContent = afterWord;
  }
}